<template>
  <Modal
    :id="'cmp-add-contact'"
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('new_contact')}}</template>

    <template slot="body">
      <div class="horiz-forms">
        <div class="form-group">
          <TextField
            v-if="ContactFuncs.isNotCompany(contact)"
            class="m1"
            :id="'first_name'"
            required
            v-bind="textFieldConfig"
            :value="contact.first_name"
            :placeholder="$t('first_name')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            v-if="ContactFuncs.isNotCompany(contact)"
            class="m1"
            :id="'last_name'"
            required
            v-bind="textFieldConfig"
            :value="contact.last_name"
            :placeholder="$t('last_name')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <div class="form-gap" v-if="ContactFuncs.isNotCompany(contact) && ContactFuncs.isNotIndividual(contact)">
            {{$t('word_or')}}
          </div>
          <TextField
            v-if="ContactFuncs.isNotIndividual(contact)"
            class="m1"
            :id="'company_name'"
            required
            v-bind="textFieldConfig"
            :value="contact.company_name"
            :placeholder="$t('company_name')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            v-if="ContactFuncs.isNotIndividual(contact)"
            class="m1"
            :id="'company_legalname'"
            required
            v-bind="textFieldConfig"
            :value="contact.company_legalname"
            :placeholder="$t('legal_name')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            v-if="ContactFuncs.isNotIndividual(contact)"
            class="m1"
            :id="'registration'"
            required
            v-bind="textFieldConfig"
            :value="contact.registration"
            :placeholder="$t('registration')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            v-if="ContactFuncs.isNotIndividual(contact)"
            class="m1"
            :id="'legal_form'"
            required
            v-bind="textFieldConfig"
            :value="contact.legal_form"
            :placeholder="$t('legal_form')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <div class="form-gap"></div>
          <TextField
            class="m1"
            :id="'address1'"
            required
            v-bind="textFieldConfig"
            :value="contact.address1"
            :placeholder="$t('address1')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'address2'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.address2"
            :placeholder="$t('address2')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation" 
          ></TextField>
          <TextField
            class="m1"
            required
            :id="'postalcode'"
            v-bind="textFieldConfig"
            :value="contact.postalcode"
            :placeholder="$t('postalcode')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
        </div>
        <div class="form-group">
          <TextField
            class="m1"
            :id="'city'"
            required
            v-bind="textFieldConfig"
            :value="contact.city"
            :placeholder="$t('city')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
            @blur="onCityBlur"
          ></TextField>
          <TextField
            class="m1"
            :id="'region'"
            v-bind="textFieldConfig"
            :value="contact.region"
            :showValidationIcons="false"
            :placeholder="$t('region')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <Dropdown
            :options="countriesTV"
            class="m2"
            required
            :showValidationIcons="true"
            :immediateValidation="true"
            :selected="countriesTV.find(e => e.value == contact.country)"
            :placeholder="$t('country')"
            v-on:selectedChange="e => onDropdownChange('country', e)"
            @validated="result => onValidation('country', result)"
            :listHeight="95"
            box
          ></Dropdown>
          <TextField
            class="m1"
            :id="'email1'"
            v-bind="textFieldConfig"
            :value="contact.email1"
            :placeholder="$t('email')"
            :validators="emailValidators"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'phone1'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.phone1"
            :placeholder="$t('phone')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'phone2'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.phone2"
            :placeholder="$t('phone2')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <div class="form-gap"></div>
          <TextField
            class="m1"
            :id="'vat_no'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.vat_no"
            :placeholder="$t('vat_id')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'tax_no'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.tax_no"
            :placeholder="$t('tax_no')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'tax_regime'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.tax_regime"
            :placeholder="$t('Tax Regime')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'tax_regime_code'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.tax_regime_code"
            :placeholder="$t('Tax Regime Code')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
        </div>
        <div class="form-group">
          <TextField
            class="m1"
            :id="'account_holder'"
            required
            v-bind="textFieldConfig"
            :value="contact.account_holder"
            :placeholder="$t('account_holder')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'iban'"
            required
            v-bind="textFieldConfig"
            :value="contact.iban"
            :placeholder="$t('iban')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'swift'"
            required
            v-bind="textFieldConfig"
            :value="contact.swift"
            :placeholder="$t('swift')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'bank_name'"
            required
            v-bind="textFieldConfig"
            :value="contact.bank_name"
            :placeholder="$t('bank_name')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'bank_address'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.bank_address"
            :placeholder="$t('bank_address')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <div class="form-gap"></div>
          <TextField
            class="m1"
            :id="'bank_postalcode'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.bank_postalcode"
            :placeholder="$t('bank_postalcode')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'bank_city'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.bank_city"
            :placeholder="$t('bank_city')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <Dropdown
            :options="countriesTV"
            class="m2"
            :selected="countriesTV.find(e => e.value == contact.bank_country)"
            :placeholder="$t('bank_country')"
            v-on:selectedChange="e => onDropdownChange('bank_country', e)"
            @validated="result => onValidation('bank_country', result)"
            :listHeight="95"
            box
          ></Dropdown>
          <Dropdown
            :options="countriesTV"
            class="m2"
            :selected="countriesTV.find(e => e.value == contact.intermediate_country)"
            :placeholder="$t('intermediate_country')"
            v-on:selectedChange="e => onDropdownChange('intermediate_country', e)"
            @validated="result => onValidation('intermediate_country', result)"
            :listHeight="95"
            box
          ></Dropdown>
          <TextField
            class="m1"
            :id="'bank_routing'"
            :showValidationIcons="false"
            v-bind="textFieldConfig"
            :value="contact.bank_routing"
            :placeholder="$t('bank_routing')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
        </div>
      </div>
    </template>

    <template slot="options">
      <button
        class="dt-button v1 s6"
        :class="{'disabled': !isFormValid}"
        :disabled="!isFormValid"
        @click.stop="addNewContact"
      >{{$t('add_new_contact')}}</button>
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
    </template>
  </Modal>
</template>

<script>
import { createValidator } from "@plugins/text-field";

import isEmail from "validator/lib/isEmail";

import Modal from '@dtplugins/modal/modal';
import { ContactFuncs } from '../../../contacts/models/contacts.model';
import { InvoicesService } from '../../services/invoices.service';
import { createCountriesTV } from '../../../../models/country.model';
import { BookingService } from '../../../booking/services/booking-service';

export default {
  components: {
    Modal
  },
  props: {
    groups: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },
      ContactFuncs: ContactFuncs,
      contact: ContactFuncs.createInvoiceContact({}),
      emailValidators: [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email"
        })
      ],
      validationResult: {},

      contactFormData: null,
    };
  },
  mounted: async function() {
    const contactFormData = await InvoicesService.findContactForm();
    console.log(contactFormData);
    this.contactFormData = contactFormData.data;
  },
  computed: {
    isFormValid: function() {
      return Object.keys(ContactFuncs.omitByType(this.contact)(this.validationResult)).map(key => {console.log(key, this.validationResult[key]?.valid) ; return this.validationResult[key]?.valid}).every(e => e);
    },
    countriesTV: function() {
      return createCountriesTV(this.contactFormData?.countries || []);
    }
  },
  methods: {
    onTextFieldValueChange: function(key, value) {
      this.contact[key] = value;
    },
    onValidation: function(name, value) {
      this.validationResult = {
        ...this.validationResult,
        [name]: value
      };
      // console.log(this.validationResult);
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    addNewContact: function(e) {
      this.$emit("done", ContactFuncs.createInvoiceContact(this.contact));
    },
    onDropdownChange: function(name, value) {
      this.contact[name] = value.value;
    },
    onCityBlur: function(name, value) {
      BookingService.findCountriesOfCity({
        city: value
      }).then(res => {
        if (res.data.countries && res.data.countries.length > 0) {
          this.contact.country = res.data.countries[0].country;
        }
      });
    }

    //MARK: Methods
  }
};
</script>

<style lang="scss">

.cmp-add-contact {
  .dt-modal--body {
    // max-height: 250px;
    // padding: 0px 30px 0px 0px;
    // margin: 0px -20px 0px 0px;
    overflow-x: hidden;
    overflow-y: auto;

    .horiz-forms {
      display: flex;
      width: 100%;
      .form-group {
        flex: 1;
        padding: 0px 30px 0px 0px;

        .form-gap {
          height: 42px;
          margin: 4.5px 0px;

          display: flex;
          flex-direction: column;
          justify-content: center;
          text-align: center;
        }
      }
    }
  }
}
</style>
